import Big from 'big.js';

import { NormalizedDeduction } from '../_types';

export const calculateDeductionPercentage = (
  weightValue: number,
  parentNet: number,
): number => {
  if (parentNet <= 0) return 0;
  return new Big(weightValue).div(parentNet).times(100).toNumber();
};

export const calculateSiblingPercentageTotal = (
  deductions: NormalizedDeduction[],
  excludeId: string,
  parentNet: number,
): number => {
  if (parentNet <= 0) return 0;
  return deductions
    .filter((d) => d.id !== excludeId && d.applicationType === 'Weight')
    .reduce((sum, d) => {
      if (d.percentage != null) return sum.plus(d.percentage);
      const dNet = d.weightValue?.value ?? 0;
      return sum.plus(new Big(dNet).div(parentNet).times(100));
    }, new Big(0))
    .toNumber();
};

export const clampPercentage = (
  percentage: number,
  siblingTotal: number,
): number => {
  const maxAllowed = Math.max(0, 100 - siblingTotal);
  return Math.min(percentage, maxAllowed);
};

export const calculateWeightFromPercentage = (
  percentage: number,
  parentNet: number,
): number => new Big(parentNet).times(percentage).div(100).toNumber();
